import React from 'react';
import { Stack, Typography } from '@mui/material';
import { colors } from '../../../designTokens';
import KnowledgeLibraryResultCard from './KnowledgeLibraryResultCard';
import { filterVisibleKnowledgeResults } from '../../freestyle/discovery/discoveryRelevanceStyles';

export default function KnowledgeDiscoveryCard({
  results = [],
  error = '',
  onAdd,
  onOpen,
}) {
  const displayedResults = filterVisibleKnowledgeResults(results);
  return (
    <Stack spacing={1.25} sx={{ mt: 1.5 }}>
      <Typography component="h3" sx={{ color: colors.textPrimary, fontSize: '1rem', fontWeight: 750, letterSpacing: '-0.015em' }}>
        Relevant knowledge
      </Typography>
      {error && (
        <Typography variant="body2" color="warning.main" sx={{ lineHeight: 1.45 }}>
          {error}. You can still attach knowledge manually.
        </Typography>
      )}
      {displayedResults.length === 0 ? (
        <Typography variant="body2" sx={{ color: colors.textSecondary }}>
          No strong saved knowledge matches. You can still choose knowledge from your library.
        </Typography>
      ) : (
        <Stack spacing={1.5}>
          {displayedResults.map((result) => {
            const item = result.context || result.raw || result;
            return (
              <KnowledgeLibraryResultCard
                key={result.id || item.id}
                result={result}
                onPreview={(ctx, res) => onOpen?.(ctx, res)}
                onAdd={onAdd}
              />
            );
          })}
        </Stack>
      )}
    </Stack>
  );
}
